import React from 'react';
import { TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import { useTheme } from '@mui/material';

export const DefaultTableHeaderCell = ({ ...props }) => {
  const { palette } = useTheme();
  const draggingEnabled =
    props.draggingEnabled &&
    !Object.prototype.hasOwnProperty.call(props, 'fixed');
  return (
    // @ts-expect-error TS(2740): Type '{ style: any; draggingEnabled: any; }' is mi... Remove this comment to see the full error message
    <TableHeaderRow.Cell
      {...props}
      style={{
        backgroundColor: palette.background.tableHeader,
        ...props.style,
      }}
      sx={{
        /*
          DevExpress lets header titles wrap, and the column's resize handle
          takes 16px out of the cell before the title gets any -- so a
          two-word title like "File Type" or "System Generated" broke onto two
          lines even in a column with room to spare, while the row beneath
          stayed single-line. Keep titles on one line everywhere and ellipsize
          the rare column that genuinely cannot fit; `title` on the content
          below makes the full label available on hover.
        */
        '& .Content-content': {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      }}
      draggingEnabled={draggingEnabled}
    />
  );
};

export const TableHeaderCellContent = (props: any) => {
  const { children, column } = props;
  const { HeaderComponent } = column;

  return (
    <TableHeaderRow.Content
      column={column}
      {...props}
      title={typeof column?.title === 'string' ? column.title : undefined}
    >
      {HeaderComponent ? <HeaderComponent {...props} /> : children}
    </TableHeaderRow.Content>
  );
};
